enum PatchOperationEnum {
  Add = 'add',
  Remove = 'remove',
  Replace = 'replace',
  Move = 'move',
  Copy = 'copy',
  Test = 'test',
}

export default PatchOperationEnum;
